import React, { useState, useEffect } from 'react';
import axios from 'axios';

const RekapAbsenGuru = ({ token }) => {
  const [bulan, setBulan] = useState(new Date().toISOString().slice(0, 7)); // YYYY-MM
  const [dataGuru, setDataGuru] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleCari = async () => {
    setLoading(true);
    try {
      // PERBAIKAN: Menggunakan relative path agar lolos CORS Nginx
      const res = await axios.get('/api/absen-guru', {
        params: { bulan },
        headers: { Authorization: `Bearer ${token}` }
      });
      setDataGuru(res.data);
    } catch (err) { 
      console.error(err);
      alert('Gagal memuat data rekap guru'); 
    }
    setLoading(false);
  };

  useEffect(() => { 
    handleCari(); 
  }, []);

  // Format Tanggal dengan Nama Hari (Contoh: Kamis, 16 Jul 2026)
  const formatHariTanggal = (isoDate) => {
    if (!isoDate) return '-';
    const date = new Date(isoDate);
    return date.toLocaleDateString('id-ID', { 
      weekday: 'long', 
      day: 'numeric', 
      month: 'short', 
      year: 'numeric' 
    });
  };

  return (
    <div style={{ paddingBottom: '50px' }}>
      
      {/* NO PRINT FILTER HEADER */}
      <div className="no-print" style={{ marginBottom: '20px' }}>
        <h2 style={{ color: '#1e293b', marginBottom: '15px' }}>👨‍🏫 Laporan Kehadiran Guru</h2>
        <div style={{ display: 'flex', gap: '10px', background: 'white', padding: '15px', borderRadius: '10px', boxShadow: '0 2px 5px rgba(0,0,0,0.05)', alignItems: 'center', flexWrap: 'wrap' }}>
          <input 
            type="month" 
            value={bulan} 
            onChange={e => setBulan(e.target.value)} 
            style={{ padding: '8px 12px', borderRadius: '6px', border: '1px solid #cbd5e1', fontWeight: 'bold' }} 
          />
          <button 
            onClick={handleCari} 
            style={{ background: '#4361ee', color: 'white', padding: '8px 20px', borderRadius: '6px', border: 'none', cursor: 'pointer', fontWeight: 'bold' }}
          >
            🔍 Tampilkan
          </button>
          <button 
            onClick={() => window.print()} 
            style={{ background: '#334155', color: 'white', padding: '8px 20px', borderRadius: '6px', border: 'none', cursor: 'pointer', fontWeight: 'bold' }}
          >
            🖨️ Cetak PDF
          </button>
        </div>
      </div>

      {/* PRINT AREA */}
      <div className="print-area" style={{ background: 'white', padding: '30px', borderRadius: '12px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)' }}>
        <div style={{ textAlign: 'center', marginBottom: '25px', borderBottom: '2px solid #1e293b', paddingBottom: '15px' }}>
          <h3 style={{ margin: '0 0 5px', color: '#1e293b', fontSize: '20px' }}>LAPORAN KEHADIRAN GURU & STAFF</h3>
          <p style={{ margin: 0, color: '#64748b' }}>Periode Bulan: <b>{bulan}</b></p>
        </div>

        {loading ? (
          <p style={{ textAlign: 'center', padding: '30px', color: '#64748b' }}>Memuat rekap data...</p>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }} border="1" borderColor="#e2e8f0">
            <thead>
              <tr style={{ background: '#f8fafc', color: '#334155' }}>
                <th style={{ padding: '10px', width: '40px' }}>No</th>
                <th style={{ padding: '10px', textAlign: 'left' }}>Hari & Tanggal</th>
                <th style={{ padding: '10px', textAlign: 'left' }}>Nama Guru / Staff</th>
                <th style={{ padding: '10px', textAlign: 'left' }}>NIP</th>
                <th style={{ padding: '10px', textAlign: 'left' }}>Mapel & Kelas</th>
                <th style={{ padding: '10px', textAlign: 'center' }}>Jam Mengajar</th>
                <th style={{ padding: '10px', textAlign: 'center' }}>Jam Absen</th>
                <th style={{ padding: '10px', textAlign: 'center' }}>Status</th>
                <th style={{ padding: '10px', textAlign: 'left' }}>Keterangan</th>
              </tr>
            </thead>
            <tbody>
              {dataGuru.length === 0 ? (
                <tr>
                  <td colSpan="9" style={{ textAlign: 'center', padding: '30px', color: '#94a3b8', fontStyle: 'italic' }}>
                    Tidak ada data kehadiran guru pada bulan ini.
                  </td>
                </tr>
              ) : (
                dataGuru.map((d, idx) => (
                  <tr key={idx} style={{ background: idx % 2 === 0 ? '#ffffff' : '#f8fafc' }}>
                    <td style={{ textAlign: 'center', padding: '10px' }}>{idx + 1}</td>
                    
                    {/* HARI & TANGGAL */}
                    <td style={{ padding: '10px', fontWeight: 'bold', color: '#1e293b', whiteSpace: 'nowrap' }}>
                      {formatHariTanggal(d.tanggal)}
                    </td>

                    {/* NAMA GURU */}
                    <td style={{ padding: '10px', fontWeight: 'bold', color: '#1e293b' }}>
                      {d.nama_guru || d.nama}
                    </td>

                    {/* NIP */}
                    <td style={{ padding: '10px', color: '#64748b' }}>
                      {d.nip || '-'}
                    </td>

                    {/* MAPEL & KELAS */}
                    <td style={{ padding: '10px' }}>
                      <div style={{ fontWeight: '600', color: '#2563eb' }}>{d.mapel || 'Piket / Pengayaan'}</div>
                      {d.nama_kelas && d.nama_kelas !== '-' && (
                        <span style={{ fontSize: '11px', background: '#dbeafe', color: '#1e40af', padding: '2px 6px', borderRadius: '4px', fontWeight: 'bold', display: 'inline-block', marginTop: '2px' }}>
                          🏫 {d.nama_kelas}
                        </span>
                      )}
                    </td>

                    {/* JAM MENGAJAR */}
                    <td style={{ textAlign: 'center', padding: '10px', fontWeight: 'bold', color: '#475569' }}>
                      {d.jam_mengajar || '-'}
                    </td>

                    {/* JAM ABSEN */}
                    <td style={{ textAlign: 'center', padding: '10px', color: '#64748b' }}>
                      {d.jam_masuk ? `${d.jam_masuk.slice(0, 5)} WIB` : '-'}
                    </td>

                    {/* STATUS */}
                    <td style={{ textAlign: 'center', padding: '10px' }}>
                      <span style={{ 
                        padding: '4px 8px', 
                        borderRadius: '6px', 
                        fontSize: '11px', 
                        fontWeight: 'bold', 
                        textTransform: 'uppercase',
                        color: d.status === 'hadir' ? '#15803d' : d.status === 'telat' ? '#b45309' : '#991b1b',
                        background: d.status === 'hadir' ? '#dcfce7' : d.status === 'telat' ? '#fef3c7' : '#fee2e2'
                      }}>
                        {d.status}
                      </span>
                    </td>

                    {/* KETERANGAN */}
                    <td style={{ padding: '10px', color: '#64748b' }}>
                      {d.keterangan || '-'}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        )}

        {/* TANDA TANGAN KEPALA SEKOLAH */}
        <div style={{ marginTop: '40px', display: 'flex', justifyContent: 'flex-end' }}>
          <div style={{ textAlign: 'center', width: '220px' }}>
            <p style={{ margin: '0 0 60px' }}>Kepala Sekolah,</p>
            <p style={{ margin: 0, fontWeight: 'bold' }}>( __________________ )</p>
          </div>
        </div>

      </div>
    </div>
  );
};

export default RekapAbsenGuru;